<div class="flex justify-center w-full">
    <div class="flex flex-row relative items-center p-2 gap-2 w-full md:w-3/5">
        <ng-icon name="faSolidMagnifyingGlass" class="absolute left-[1.2rem]" size="16" color="#CC4A1E"></ng-icon>
        <input class="flex-auto rounded pl-[2.2rem]" type="text" [formControl]="query">
        <ng-icon class="absolute z-1000 right-5 items-center cursor-pointer" name="faSolidXmark" size="16"
            color="#CC4A1E" (click)="query.reset()"></ng-icon>
    </div>
</div>